(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Homepage scroll logic for white theme
      if (window.location.pathname === '/' || document.body.classList.contains('template-index')) {
         if (scrollTop > 100) { 
             this.header.classList.add('scrolled-white-theme');
         } else {
             this.header.classList.remove('scrolled-white-theme');
         }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MobileAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.inner = this.querySelector('.mobile-announcement-bar__inner');
      this.items = Array.from(this.querySelectorAll('.mobile-announcement-bar__item'));
      this.currentIndex = 0;
      this.intervalTime = 5000;
      this.timer = null;
    }

    connectedCallback() {
      if (this.items.length === 0) return;
      
      this.initMarquee();
      
      if (this.items.length > 1) {
        this.startAutoSlide();
      }
    }

    disconnectedCallback() {
      this.stopAutoSlide();
    }

    initMarquee() {
      this.items.forEach(item => {
        const textWrapper = item.querySelector('.mobile-announcement-bar__text-wrapper');
        const textElement = item.querySelector('.mobile-announcement-bar__text');
        
        if (textElement.offsetWidth > textWrapper.offsetWidth) {
          // Clone the text for continuous marquee
          const clone = textElement.cloneNode(true);
          textElement.style.paddingRight = '50px';
          clone.style.paddingRight = '50px';
          
          textElement.classList.add('is-marquee');
          textElement.appendChild(clone);
          
          // Adjust speed based on length
          const duration = (textElement.offsetWidth / 50) + 's';
          textElement.style.animationDuration = duration;
        }
      });
    }

    startAutoSlide() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        this.inner.style.transform = `translateY(-${this.currentIndex * 30}px)`;
      }, this.intervalTime);
    }

    stopAutoSlide() {
      if (this.timer) clearInterval(this.timer);
    }
  }
  customElements.define('mobile-announcement-bar', MobileAnnouncementBar);

  } catch(e) { console.error(e); }
})();
})();
